const triggers = [...document.querySelectorAll('.js-slide-up')];
const dismissers = [...document.querySelectorAll('.js-dismiss-slide-up')];
const overlays = [...document.querySelectorAll('.slide-up-overlay')];

triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
        const { target } = trigger.dataset;
        let panel = document.querySelector('.js-slide-up-panel');

        if (target) {
            panel = document.querySelector(`.js-slide-up-panel[data-type="${target}"]`);
        }

        panel.classList.toggle('is-active');
        document.body.classList.toggle('is-locked');
    });
});

dismissers.forEach((dismisser) => {
    dismisser.addEventListener('click', () => {
        const panel = dismisser.closest('.js-slide-up-panel');
        panel.classList.toggle('is-active');
        document.body.classList.toggle('is-locked');
    });
});

overlays.forEach((overlay) => {
    overlay.addEventListener('click', () => {
        overlay.parentElement.classList.toggle('is-active');
        document.body.classList.toggle('is-locked');
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/slide-up.js